import React, { useState } from "react";
import { deletePhotos } from "../API/api";
const alertIcon = require("../../ManagePrepaidCustomers/components/images/alert.svg");

interface ConfirmDeletePhotoProps {
  onClose: () => void;
  selectedMediaId: Array<number>;
  selectedEventId: number;
  onDeletePhotoSuccess: () => void;
  selectedAlbumId: number;
  parent?: string;
}

const ConfirmDeletePhoto: React.FC<ConfirmDeletePhotoProps> = ({
  onClose,
  selectedMediaId,
  selectedEventId,
  onDeletePhotoSuccess,
  selectedAlbumId,
  parent
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <div>
      <div
        id="filter-dialog"
        className={`modal fade in geo-modal geo-multi-modal ${
          parent == "lightbox" && "confirm-delete-modal"
        }`}
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content ws-delete-modal">
          <div className="geo-modal__header geo-modal--warning-bg geo-del-header">
            <img
              className="geo-modal__warn-icon"
              src={alertIcon}
              alt="exclamation-warn"
            />
            <h4>Deleting Photo</h4>
          </div>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-content">
            <p>Would you like to proceed?</p>{" "}
            <div className="modal-footer geo-modal__actions dont-break ws-delete-footer-btns">
              <button
                className="geo-btn geo-btn--link geo-btn--caps"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                className="geo-btn geo-btn--secondary geo-btn--caps"
                style={{ padding: "12px 30px", marginLeft: "15px" }}
                onClick={() =>
                  deletePhotos(
                    selectedMediaId,
                    onDeletePhotoSuccess,
                    selectedAlbumId
                  )
                }
                disabled={loading}
              >
                {loading ? (
                  <div className="loading-spinner">
                    <span className="fa fa-spinner fa-spin"></span>
                  </div>
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal-backdrop fade in ${
          parent == "lightbox" && "confirm-photo-delete-popup-backdrop"
        }`}
      />
    </div>
  );
};

export default ConfirmDeletePhoto;
